export default __webpack_public_path__ + "static/media/content-img-2.01ac1ab0.jpg";